import axios from "axios";
import store from "@/store";
import { Message } from "element-ui";
// import { getToken } from "@/utils/auth";

axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    Accept: "*/*",
  },
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 900000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    const { token = "" } = store.getters.GET_USER_INFO;

    if (token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers["token"] = token;
    } else {
      config.headers["token"] = "";
    }
    return config;
  },
  (error) => {
    // do something with request error
    // console.log(error); // for debug
    return Promise.reject(error);
  }
);


let status = true

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const res = response.data;
    if (
      response.config &&
      response.config.url &&
      response.config.url.indexOf("/common/download") > -1
    ) {
      return response;
    }
    
    if (res.code && res.code !== 200 && status ) {
       
      /* 90012,"登录已失效，请重新登录"    90011,"登录已过期，请重新登录" */
      if ( res.code === 90011) {
          store.commit("REMOVE_USER_INFO");
          router.push('/login')
      }else if(res.code === 94002){
          Message({
            message: res.message,
            type: "error",
          })
      }else if(res.code === 90004){
        Message({
            message: res.message,
            type: "error",
          })
      }
      status = false
      // Message({
      //   message: res.message || "Error",
      //   type: "error",
      //   duration: 5 * 1000,
      // });

      let timeout = setTimeout(() => {
        status = true;
        clearTimeout(timeout);
      }, 1500)
      
     //return Promise.reject(new Error(res.message || "Error"));

      // if (res.code === 90011) { // 登录已过期，请重新登录
      //     store.commit("REMOVE_USER_INFO");
      //     router.push()
      // }
    } else {
      return res;
    }
  },
  (error) => {
    console.log("err" + error); // for debug
    Message({
      message: error.message,
      type: "error",
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);

export default service;
